import React, { useContext, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Typography, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@material-ui/core';
import { I18nContext } from 'translations';
import { useForm, Controller } from 'react-hook-form';
import { HOURS_DEDICATED } from 'utils/constants';
import { editHoursDedicated } from 'context/express/actions';
import { useStateValue } from 'context/store';
import { modalMessage, formatCost } from 'utils';
import { INITIAL_PAGE } from 'utils/constants';
import { quoteScheduleF } from 'context/express/actions';
import { messageReservation as closeMessage } from 'context/commons/actions';

export default function ModalHoursDedicated({ handleModal, open, bookingSelected, getBookings, editReservation = false }) {
  const { translate } = useContext(I18nContext)
  const [loading, setLoading] = useState(false)
  const [{ bookings: { quoteSchedule, loadingQuote } }, dispatch] = useStateValue();

  const { handleSubmit, control, getValues } = useForm();

  const messageOk = (mssg) => {
    modalMessage('', mssg, 'success', translate('accept'), true).then(() => {
      setLoading(false);
      handleModal();
      getBookings(INITIAL_PAGE);
      closeMessage(dispatch, null)
    })
  }

  const submit = async (values) => {
    setLoading(true)
    const callback = await editHoursDedicated(bookingSelected.bookingId ? bookingSelected.bookingId : bookingSelected._id, values, dispatch)
    callback.status ? messageOk(callback?.mssgOk) : setLoading(false)
  }

  function addHourAndMinutes(fechaISO, minutos) {
    const fecha = new Date(fechaISO);
    fecha.setMinutes(fecha.getMinutes() + 240 + minutos);
    return fecha.toISOString().replace('Z', '-05:00');
  }

  const submitQuote = async () => {
    const originalDate = bookingSelected?.scheduled_at
    const formattedDate = addHourAndMinutes(originalDate, 60)
    
    const booking = {
      booking: {
        stops: [{ packages: [] }],
        ...bookingSelected,
        scheduled_at: formattedDate,
        hours_dedicated: getValues('hours_dedicated'),
      }
    }
    await quoteScheduleF(booking, dispatch)
  }

  return (
    <Dialog
      open={open}
      onClose={handleModal}
      maxWidth={editReservation ? "sm" : "xs"}
      fullWidth
    >
      <Typography className={editReservation ? "text-left" : "text-center"} variant="h5" color="primary" style={{ padding: 20 }}>
        {editReservation ? translate('hoursDedicated.exceedReservationTime') : translate('hoursDedicated.title')}
      </Typography>
      <DialogContent>
        {editReservation && (
          <Typography component="p" className="text-left" variant="body1" style={{ marginBottom: '20px' }}>
            {translate('hoursDedicated.exceedReservationTime.description')}
          </Typography>
        )}
        <form onSubmit={handleSubmit(submit)} noValidate>
          {editReservation &&
            <FormControl fullWidth className="text-left" variant="outlined" size="small" style={{ marginBottom: '20px' }}>
              <Typography><b>{translate('hoursDedicated.exceedReservationTime.actualReservation')}: </b> {bookingSelected.hours}</Typography>
              <Typography><b>{translate('hoursDedicated.exceedReservationTime.actualReservationValue')}: </b> {bookingSelected.estimated_cost ? formatCost(bookingSelected.estimated_cost) : ' - '}</Typography>
            </FormControl>
          }
          <FormControl fullWidth className="text-left" variant="outlined" size="small" style={{ marginBottom: '17px' }}>
            <InputLabel>{translate('hoursDedicated.title')}</InputLabel>
            <Controller
              control={control}       
              name="hours_dedicated"
              defaultValue={bookingSelected?.hours ? bookingSelected.hours : 0}
              label={translate('hoursDedicated.title')}
              as={
                <Select>
                  {bookingSelected.status_cd === 4 && bookingSelected.hours <= 12 ?
                    HOURS_DEDICATED.map(hours => {
                      if (hours >= bookingSelected.hours && hours <= bookingSelected.hours + 2) {
                        return <MenuItem key={hours} value={hours}>
                          {hours}
                        </MenuItem>
                      } return null
                    })
                  :
                  HOURS_DEDICATED.map(hours => (
                    <MenuItem key={hours} value={hours}>
                      {hours}
                    </MenuItem>
                  ))}
                </Select>
              }
            />
          </FormControl>

          {editReservation && quoteSchedule &&
            <FormControl fullWidth className="text-left" variant="outlined" size="small" style={{ marginBottom: '17px' }}>
              <Typography><b>{translate('hoursDedicated.exceedReservationTime.newServiceValue')}: </b> {quoteSchedule.quotation?.estimated_fare ? formatCost(quoteSchedule.quotation.estimated_fare) : ' - '}</Typography>
            </FormControl>
          }
          {editReservation &&
            <FormControl fullWidth className="text-left" variant="outlined" size="small" style={{ marginBottom: '17px' }}>
              <Typography color="primary"><i><b>{translate('hoursDedicated.note')}: </b> {translate('hoursDedicated.note.description')}</i></Typography>
            </FormControl>
          }
          <div className={editReservation ? 'text-right': 'text-center'} style={{ marginTop: '10px' }}>
            {editReservation && (
              <Button
                type="button"
                color="secondary"
                variant="contained"
                onClick={submitQuote}
                startIcon={loadingQuote ? <CircularProgress size={18} /> : null}
                disabled={loadingQuote}
                style={{ marginRight: '10px' }}
              >
                {translate('hoursDedicated.exceedReservationTime.estimate')}
              </Button>
            )}
            <Button
              type="submit"
              color="primary"
              variant="contained"
              startIcon={loading ? <CircularProgress size={18} /> : null}
              disabled={loading}
            >
              {editReservation ? translate('hoursDedicated.exceedReservationTime.confirmNewServiceValue') : translate('save')}
            </Button>
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleModal}
        >
          {translate('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}